import { FC } from 'react';
import { useChartWidth, YAxis } from 'recharts';
import { chartLabelColumnWidth } from './chartAxis';
import { ChartCategoryTick } from './ChartCategoryTick';

type Props = {
  /** Поле точки, в котором лежит название элемента */
  dataKey: string;
  /** Место, уже отведённое под величины ряда: название отмеряется от того, что осталось */
  valueWidth: number;
  /** Доля ширины диаграммы под названия, заданная пользователем; не задана — место отмеряется само */
  labelWidth?: number;
};

/**
 * Ось названий полос: место под название отмеряется по ширине самой диаграммы, а не постоянной.
 *
 * Ось вынесена в свой компонент, потому что ширину диаграммы знает только сама диаграмма: доля
 * сетки, в которой стоит карточка, меняется вместе с размером диаграммы и шириной окна, и снаружи
 * место под название пришлось бы отмерять наперёд — тем самым постоянным, из-за которого на тесной
 * карточке дорожке не оставалось длины.
 */
export const ChartCategoryAxis: FC<Props> = ({ dataKey, valueWidth, labelWidth }) => {
  const chartWidth = useChartWidth();
  // Место под величину берётся у названия, а не у дорожки: величину ни усечь, ни перенести на
  // вторую строку нельзя, а название усечённым остаётся доступным подсказкой.
  const width = chartLabelColumnWidth(chartWidth ?? 0, valueWidth, labelWidth);

  return (
    <YAxis
      type="category"
      dataKey={dataKey}
      width={width}
      // Название показано у каждой строки: место под подпись библиотека отмеряет по своей мерке и
      // на тесной строке деление прячет целиком — название пропадало бы вместе с ним, недоступное
      // даже подсказкой.
      interval={0}
      // Засечка и её отступ обнулены: иначе подпись сдвигается за левый край рисунка и первый знак
      // названия срезается. Отступ до полосы задан внутри самой подписи.
      tickSize={0}
      tickMargin={0}
      tick={<ChartCategoryTick width={width} />}
      tickLine={false}
      axisLine={false}
    />
  );
};
